<div [class]="classes?.root">
    <ng-content></ng-content>
</div>
